/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "semantic_aim";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AimMode {
}

export enum AimMode_Enum {
  INVALID = 0,
  VISUAL_SERVO = 1,
  SUBJECT_TRACK = 2,
  DETECTION = 3,
  DETECTION_DYNAMIC = 4,
  UNRECOGNIZED = -1,
}

export function aimMode_EnumFromJSON(object: any): AimMode_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return AimMode_Enum.INVALID;
    case 1:
    case "VISUAL_SERVO":
      return AimMode_Enum.VISUAL_SERVO;
    case 2:
    case "SUBJECT_TRACK":
      return AimMode_Enum.SUBJECT_TRACK;
    case 3:
    case "DETECTION":
      return AimMode_Enum.DETECTION;
    case 4:
    case "DETECTION_DYNAMIC":
      return AimMode_Enum.DETECTION_DYNAMIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AimMode_Enum.UNRECOGNIZED;
  }
}

export function aimMode_EnumToJSON(object: AimMode_Enum): string {
  switch (object) {
    case AimMode_Enum.INVALID:
      return "INVALID";
    case AimMode_Enum.VISUAL_SERVO:
      return "VISUAL_SERVO";
    case AimMode_Enum.SUBJECT_TRACK:
      return "SUBJECT_TRACK";
    case AimMode_Enum.DETECTION:
      return "DETECTION";
    case AimMode_Enum.DETECTION_DYNAMIC:
      return "DETECTION_DYNAMIC";
    case AimMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAimMode(): AimMode {
  return {};
}

export const AimMode = {
  encode(_: AimMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AimMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAimMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AimMode {
    return {};
  },

  toJSON(_: AimMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AimMode>, I>>(base?: I): AimMode {
    return AimMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AimMode>, I>>(_: I): AimMode {
    const message = createBaseAimMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
